'use strict';

(function (window, document, $) {

    if ($('.fn-restaurant').length > 0) {
        var tabber = $('.fn-restaurant-tabber');
        var tab = $('.fn-restaurant-tab');
        
        var slickOptions = {
            fade: true,
            autoplay: true,
            autoplaySpeed: 5000,
            lazyLoad: 'ondemand',
            nextArrow: '<button type="button" class="slick-next"><span class="lnr lnr-chevron-right"></span></button>',
            prevArrow: '<button type="button" class="slick-prev"><span class="lnr lnr-chevron-left"></span></button>'
        };

        $('.smak-slider').slick(slickOptions);
        $('.lounge-slider').slick(slickOptions);

        tab.click(function() {
            var self = $(this);

            $('.fn-restaurant').attr('data-tab', self.attr('data-tab'));

            $('.fn-restaurant-tab').removeClass('active');
            self.addClass('active');

            $('.fn-restaurant-content-item').hide();
            $('.fn-restaurant-content-item[data-tab="'+ self.attr('data-tab') +'"]').show();

            $('.fn-restaurant-content-item[data-tab="'+ self.attr('data-tab') +'"]').find('.restaurant-slider').slick('unslick');
            $('.fn-restaurant-content-item[data-tab="'+ self.attr('data-tab') +'"]').find('.restaurant-slider').slick(slickOptions);
        });

    }

})(window, document, jQuery);